import {
    DISCIPLINES_FAILURE,
    DISCIPLINES_REQUEST,
    DISCIPLINES_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
};

export const disciplineListReducer = (state = initialState, action) => {
    const {type, data} = action;
    switch (type) {
        case DISCIPLINES_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            data: preserveArrayReference(state.data, data),
        }}

        case DISCIPLINES_REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case DISCIPLINES_FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
